import { createAction, createSlice } from '@reduxjs/toolkit';
import { CoreMsgTypes, PriceRecord } from '@tassat/fred-definitions';

export interface PricesState {
    [key: string]: PriceRecord;
}

const initialState: PricesState = {};

const initialLoadAction = createAction<{ priceRecords: PricesState }>('InitialLoad');
const priceRecordAction = createAction<PriceRecord>(CoreMsgTypes.PriceRecord);

const pricesSlice = createSlice({
    name: 'prices',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoadAction, (_state, action) => {
                return action.payload.priceRecords;
            })
            .addCase(priceRecordAction, (state, action) => {
                state[action.payload.AssetId] = action.payload;
            });
    }
});

export default pricesSlice.reducer;